module.exports = __webpack_public_path__ + "img/signal.19d9feab.svg";